import React, { useState } from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import './emailStyles.scss';
const germanMonthNames = {
  'January':'Januar','February':'Februar','March':'März','April':'April','May':'Mai','June':'Juni','July':'Juli',
  'August':'August','September':'September','October':'Oktober','November':'November','December':'Dezember',
};

export function CustomHeader({date,decreaseMonth,prevMonthButtonDisabled,changeYear,changeMonth,increaseMonth,
  nextMonthButtonDisabled,years,months}) {
  const [showYears, setShowYears] = useState(false);
  const [showMonths, setShowMonths] = useState(false);
  years = years.reverse();
  return (
    <div className='controls-container'>
      <input onClick={decreaseMonth} disabled={prevMonthButtonDisabled} type='button' value='<' className='btn'></input>

      <div className={'btn'} 
      onClick={()=>{setShowYears(!showYears);setShowMonths(false)}} 
      >{date.getFullYear()}
          <div className={showYears?'calendar-main-div':'hide'} style={{left:'1rem'}}>
            {years.map(year=>
              <div key={year} 
              className='calendar-options'
              onClick={()=>{changeYear(year); setShowYears(false)}}
              >{year}</div>
            )}
          </div>
      </div>

      <div className={'btn'} 
      onClick={()=>{setShowMonths(!showMonths);setShowYears(false)}} 
      >{months[date.getMonth()]}
      <div className={showMonths?'calendar-main-div':'hide'} style={{left:'7rem'}}>
        {months.map(month=>
            <div key={month} 
            className='calendar-options'
            onClick={()=>{changeMonth(months.indexOf(month)); setShowMonths(false)}}
            >{germanMonthNames[month]}</div>
            )}
          </div>
      </div>

      {/* <select
      className='select-year'
        value={date.getFullYear()}
        onChange={({ target: { value } }) => changeYear(value)}
      >
        {years.map((option) => (
          <option key={option} value={option} className='calendar-options'>
            {option}
          </option>
        ))}
      </select>

      <select
      className='select-year'
        value={months[date.getMonth()]}
        onChange={({ target: { value } }) =>
          changeMonth(months.indexOf(value))
        }
      >
        {months.map((option) => (
          <option key={option} value={option} className='calendar-options'>
            {option}
          </option>
        ))}
      </select> */}
      <input onClick={increaseMonth} disabled={nextMonthButtonDisabled} type='button' value='>' className='btn'></input>
    </div>
  )
}